package meineglasfaser.api.routes

import io.ktor.resources.*

@Resource("/external")
class ExternalRoutes {
    @Resource("/laho")
    class Laho(val parent: ExternalRoutes = ExternalRoutes()) {
        @Resource("/new")
        class New(val parent: Laho = Laho())
    }
}
